import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import usersReducer from './usersSlice';

const rootReducer = combineReducers({
    user: userReducer,
    users: usersReducer,
});

export const store = configureStore({
    reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
